interface IReferenceAreaShapeProps {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  clipPath?: string;
  fill?: string;
  fillOpacity?: number;
  stroke?: string;
  strokeOpacity?: number;
  strokeWidth?: number;
  strokeDasharray?: string;
}
/**
 * Renders a ReferenceArea as an ellipse inscribed in its rect, which keeps the
 * radius in inches (i.e. it scales with the axes) instead of pixels.
 */
export const BreakReferenceArea = ({
  x,
  y,
  width,
  height,
  clipPath,
  fill,
  fillOpacity,
  stroke,
  strokeOpacity,
  strokeWidth,
  strokeDasharray,
}: IReferenceAreaShapeProps) => {
  if (
    x === undefined ||
    y === undefined ||
    width === undefined ||
    height === undefined
  ) {
    return null;
  }

  return (
    <ellipse
      cx={x + width / 2}
      cy={y + height / 2}
      rx={width / 2}
      ry={height / 2}
      clipPath={clipPath}
      fill={fill}
      fillOpacity={fillOpacity}
      stroke={stroke}
      strokeOpacity={strokeOpacity}
      strokeWidth={strokeWidth}
      strokeDasharray={strokeDasharray}
    />
  );
};
